import React from 'react';
import PropTypes from 'prop-types';
import { Controller } from 'react-hook-form';

import Chip from 'shared/components/forms/Chip/Chip';

const ChipListSingle = ({ name, options, control, onChange, disabled, required }) => (
  <Controller
    control={control}
    name={name}
    required={required}
    defaultValue={[]}
    render={({ field }) =>
      options.map(({ value, text, showOnNewLine }, index) => {
        const isSelected = field.value?.includes(value);

        return (
          <Chip
            key={value}
            name={`${name}[${index}]`}
            text={text}
            value={value}
            selected={isSelected}
            showOnNewLine={showOnNewLine}
            onChange={() => {
              const newValue = isSelected ? [] : [value];
              field.onChange(newValue);
              if (onChange) onChange(newValue);
            }}
            disabled={disabled}
          />
        );
      })
    }
  />
);

ChipListSingle.propTypes = {
  name: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired,
      showOnNewLine: PropTypes.bool,
    }),
  ).isRequired,
  control: PropTypes.shape({}).isRequired,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
};

export default ChipListSingle;
